import BadgeNext from "ds/components/BadgeNext";

type MainNavigationBetaIndicatorProps = {
  className?: string;
};

const MainNavigationBetaIndicator = ({ className }: MainNavigationBetaIndicatorProps) => {
  return <BadgeNext variant="blue" text="BETA" type="strong" className={className} />;
};

export default MainNavigationBetaIndicator;
